<template>
  <span class="bz-beta-wrap">
    <button v-if="!saved" class="bz-beta" type="button" @click="tryBeta" title="Switch to the new selector">
      <i class="material-icons" style="font-size:13px;line-height:1;">science</i>
      Try the new selector
    </button>
    <span v-else class="bz-beta" style="cursor:default;">
      <i class="material-icons" style="font-size:13px;line-height:1;">check_circle</i>
      Loading the new selector…
    </span>
  </span>
</template>

<script>
// Mirror pill shown on the CLASSIC selector pages. Sets the override person
// property, then switches the user into the Beta selector.
//
// Two cases:
//  - Profile selectors (ifp/imp/company_profile/prospect_list) are standalone
//    SelectorGate routes, so a reload re-runs the gate and renders the Beta.
//  - Report selectors are ALSO rendered inline as children of the report-
//    creation wizard (CreateReportFormat), where a reload just resets the
//    wizard to its inputs step and the Beta never mounts. There we navigate to
//    the standalone gate route carrying ?data-id, so the Beta ReportPage mounts
//    and preselects the chosen input set.
import { setSelectorOverride } from './flag';

// report product -> its standalone SelectorGate route name
const REPORT_ROUTE = {
  financial_report: 'NewProfile',
  market_report: 'NewMarketProfile',
  valuation_report: 'NewValuationReport',
  company_report: 'NewCompanyReport',
};

export default {
  name: 'try-beta-pill',
  props: {
    product: { type: String, required: true },
    // the selected saved-input set id, when this pill is inside the report-
    // creation wizard (so the Beta report can preselect it via ?data-id)
    dataId: { type: [String, Number], default: null },
  },
  data() {
    return { saved: false };
  },
  methods: {
    async tryBeta() {
      this.saved = true;
      // wait until the flag actually serves 'beta' — switching earlier makes
      // the gate read the stale cached variant and miss a visit
      await setSelectorOverride(this.product, 'beta');
      const routeName = REPORT_ROUTE[this.product];
      const dataId = this.dataId || this.$route.query['data-id'];
      if (routeName && this.$route.name !== routeName) {
        // inside the report-creation wizard — route to the standalone gate
        const query = dataId ? { 'data-id': String(dataId) } : {};
        this.$router.push({ name: routeName, query }).catch(() => {});
      } else {
        setTimeout(() => window.location.reload(), 500);
      }
    },
  },
};
</script>

<style>
/* Minimal standalone styling so the pill renders on classic pages, which do
   not load the Beta stylesheet. Values match the Beta design tokens. */
.bz-beta-wrap { position: relative; display: inline-flex; vertical-align: middle; }
.bz-beta {
  display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px;
  border-radius: 99px; background: #e8eef4; color: #003666; font-size: 12px;
  font-weight: 600; border: 1px solid #c9d8e6; cursor: pointer; font-family: inherit;
}
</style>
